import { apiCustomer } from "@/api"
import { parseBirthdayDate, type BirthdayDate } from "./calendar"

/** What customer-service-gateway knows about the logged customer's birthday (`GET /me/birthday`). */
export type BirthdayStatus = {
  birthday: BirthdayDate | null
  promptDeclined: boolean
}

function birthdayOf(raw: unknown): BirthdayDate | null {
  if (typeof raw !== "object" || raw === null || !("day" in raw) || !("month" in raw)) return null
  return parseBirthdayDate(String(raw.day), String(raw.month))
}

function statusOf(raw: unknown): BirthdayStatus | null {
  if (typeof raw !== "object" || raw === null || !("birthday" in raw)) return null
  const declinedAt = "promptDeclinedAt" in raw ? raw.promptDeclinedAt : null
  return { birthday: birthdayOf(raw.birthday), promptDeclined: typeof declinedAt === "string" && declinedAt !== "" }
}

/** The logged customer's birthday and prompt decline, or null when the read fails (callers then never prompt). */
export async function fetchBirthdayStatus(): Promise<BirthdayStatus | null> {
  try {
    const { data } = await apiCustomer.get<unknown>("/me/birthday")
    return statusOf(data)
  } catch {
    return null
  }
}

/** Stores the day and month (no year); customer-service-core validates the date again. */
export async function saveBirthday({ day, month }: BirthdayDate): Promise<void> {
  await apiCustomer.put("/me/birthday", { day, month })
}

/** Records "Não quero informar" on the customer profile, so no device asks again; repeat calls are harmless. */
export async function declineBirthdayPrompt(): Promise<void> {
  await apiCustomer.post("/me/birthday/decline")
}

/** True when the customer has no birthday and never declined the prompt. */
export function needsBirthdayPrompt(status: BirthdayStatus): boolean {
  return status.birthday === null && !status.promptDeclined
}
